import React from 'react';
import CourseTemplate from '../../components/CourseTemplate';

const BComGeneralCoursePage: React.FC = () => {
  const courseData = {
    title: "B.Com. General",
    shortName: "B.Com.",
    duration: "3 years",
    description: "Bachelor's degree program focused on commerce, accounting, business studies, and financial management",
    overview: "Bachelor of Commerce General (B.Com. General) is a 3-year undergraduate program that provides comprehensive study of commerce, accounting, business law, economics, and management principles. This course covers financial accounting, cost accounting, business statistics, taxation, and business communication, preparing students for careers in accounting, finance, banking, and business management.",
    eligibility: [
      "10+2 with Commerce/Science/Arts",
      "Minimum 50% marks in 12th standard",
      "Mathematics/Business Mathematics preferred",
      "Interest in business and financial matters"
    ],
    
    curriculum: [
      {
        year: 1,
        subjects: [
          "Financial Accounting",
          "Business Organization",
          "Business Economics",
          "Business Mathematics",
          "English Communication",
          "Computer Applications"
        ]
      },
      {
        year: 2,
        subjects: [
          "Cost Accounting",
          "Company Law",
          "Banking and Insurance",
          "Business Statistics",
          "Income Tax",
          "Marketing Management"
        ]
      },
      {
        year: 3,
        subjects: [
          "Advanced Accounting",
          "Financial Management",
          "Auditing",
          "Goods and Service Tax",
          "Project Work",
          "Internship"
        ]
      }
    ],

    careerProspects: {
      roles: [
        "Accountant",
        "Financial Analyst",
        "Tax Consultant",
        "Banking Professional",
        "Audit Assistant",
        "Business Analyst",
        "Insurance Agent",
        "Investment Advisor",
        "Bookkeeper",
        "Financial Planner"
      ],
      industries: [
        "Banking and Finance",
        "Accounting Firms",
        "Insurance Companies",
        "Corporate Sector",
        "Government Organizations",
        "Tax Consultancy",
        "Stock Exchanges",
        "Mutual Funds",
        "NBFCs",
        "Audit Firms"
      ],
      averageSalary: "₹2.5-6 LPA (Fresher), ₹8-25 LPA (Experienced)",
      topRecruiters: [
        "SBI, HDFC Bank, ICICI",
        "Deloitte, PwC, EY, KPMG",
        "LIC, HDFC Life",
        "Wipro, TCS (Finance)",
        "Government Departments",
        "CA Firms"
      ]
    },

    admissionProcess: [
      "Merit-based admission through 12th marks",
      "Some universities conduct entrance tests",
      "Cut-off based selection",
      "Online application process",
      "Direct admission in most colleges"
    ],

    topColleges: [
      {
        name: "Shri Ram College of Commerce",
        location: "Delhi",
        fees: "₹40,000 per year",
        ranking: "NIRF Ranking: 1"
      },
      {
        name: "Loyola College",
        location: "Chennai",
        fees: "₹45,000 per year",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "St. Xavier's College",
        location: "Mumbai",
        fees: "₹35,000 per year",
        ranking: "NAAC A+ Grade"
      },
      {
        name: "Christ University",
        location: "Bangalore",
        fees: "₹1,60,000 per year",
        ranking: "NIRF Ranking: 25"
      },
      {
        name: "Presidency College",
        location: "Chennai",
        fees: "₹15,000 per year",
        ranking: "Premier Government College"
      }
    ],

    skills: [
      "Financial Accounting",
      "Taxation Knowledge",
      "Business Analysis",
      "Computer Skills",
      "Communication Skills",
      "Mathematical Skills",
      "Attention to Detail",
      "Analytical Thinking",
      "Time Management",
      "Ethical Practices"
    ],

    futureScope: "Strong growth prospects with increasing business activities, digital accounting, GST implementation, and growing need for financial professionals in all sectors.",

    faqs: [
      {
        question: "What career opportunities exist after B.Com?",
        answer: "Career options include accounting, banking, financial services, taxation, auditing, business analysis, and further studies like M.Com, MBA, or professional courses like CA, CS, CMA."
      },
      {
        question: "Can I pursue CA after B.Com?",
        answer: "Yes, B.Com provides excellent foundation for CA. You can directly appear for CA Intermediate after graduation and get exemption in some subjects."
      },
      {
        question: "Are there government job opportunities?",
        answer: "Yes, many government positions in banks, PSUs, tax departments, and administrative services recruit B.Com graduates through competitive exams."
      },
      {
        question: "Can I work in private sector with B.Com?",
        answer: "Yes, private companies across all sectors hire B.Com graduates for accounting, finance, sales, and administrative roles."
      }
    ]
  };

  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-black flex flex-col items-center justify-start py-8 px-2">
      <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-pink-400 to-purple-400 drop-shadow-glow mb-6 text-center animate-glow">
        {courseData.title}
      </h1>
      <div className="w-full max-w-4xl">
        <CourseTemplate courseData={courseData} />
      </div>
    </div>
  );
};

export default BComGeneralCoursePage;
